// Dependencies
import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

import getClassNames from 'classnames';
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';
// Components
import NavLink from '../nav-link';
import ProfileLink from '../app-bar/profile-link';
import Support from './support/container';
import { RaisedButton } from 'material-ui';
import Notification from './notification/container';

import { openWalkThru } from '../../stores/ui/components/walkthru/walkthru-actions';
import MassMessageDialog from '../massmessaging/dialog';

// Stores
import langaugeObj from '../../localization/languages.json';
const languageSettings = langaugeObj['en-US'];
const logoGlobeSrc = require('../../../www/images/tourconnect-logo-globe.svg');
const logoNameSrc = require('../../../www/images/tourconnect-logo-name.svg');
import GetVerified from '../get-verified';
import WallWrapper from '../wall/wrapper';

import R from 'ramda';
import { getIn } from '../../utils/functional';
import HoverableMenuItem from './hoverable-menu-item';

import {
  partnersMenu,
  salesMarketingMenu,
  supplierContractingMenu,
  buyerContractingMenu,
} from './subMenuItems';

class AppBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: '',
      profileDialogOpen: false,
      windowWidth: window.innerWidth,
    };
  }
  /**
   * Add event listener
   */
  componentDidMount() {
    const { location: { pathname }, dispatch, user } = this.props;
    window.addEventListener('resize', this.updateDimensions.bind(this));
    this.shouldRouteToNotFound(pathname, user, dispatch);
  }

  componentWillUpdate(nextProps) {
    const { dispatch, user } = this.props;

    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.shouldRouteToNotFound(nextProps.location.pathname, user, dispatch);
    }
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }
  updateDimensions() {
    this.setState({ windowWidth: window.innerWidth });
  }

  shouldRouteToNotFound = (pathname, user, dispatch) => {
    if (user.isDummyAccount && !user.isAnAdmin) {
      // console.log(pathname, pathname !== '/notfound'
      //   , pathname.indexOf('/contracting/draft/') !== 0
      //   , pathname.indexOf('/contracting/template/') !== 0
      //   , pathname.indexOf('/contracting/contract/') !== 0
      //   , pathname.indexOf('/contracting/mass-rate-change/') !== 0);
      if (
        pathname !== '/notfound'
        && pathname.indexOf('/contracting/draft/') !== 0
        && pathname.indexOf('/contracting/template/') !== 0
        && pathname.indexOf('/contracting/contract/') !== 0
        && pathname.indexOf('/contracting/mass-rate-change/') !== 0
        && pathname.indexOf('/contracting/reports/diff/draft') !== 0
      ) {
        dispatch(pushAction('/notfound'));
      }
    }
  };
  render() {
    const {
      user: userState,
      contractListSearchParams,
      templateListSearchParams,
      contractListType,
      AIToolsClicked,
    } = this.props;
    const { allApps } = userState;
    const showMobileAppBar = this.state.windowWidth && this.state.windowWidth < 1069;
    const showOnboardingAppBar = userState.unApprovedShellAccount
    || showMobileAppBar
    || (userState.isDummyAccount && !userState.isAnAdmin);
    const classes = getClassNames('app-bar', this.props.className, {
      'is-not-logged-in': !(userState.user.userID),
      'is-on-onboarding': showOnboardingAppBar,
      'is-on-admin': window.location.hash.split('/')[2] === 'admin',
      'is-on-modal': this.state.modal,
    });
    const usersAITools = R.intersection(allApps || [], [
      'bookings', 'emailAssist', 'itineraryAssist', 'stopSales'
    ]);

    const openURLInNewTab = () => {
      let url = `https://tourconnect.ai/activate-ai-dmcs`;

      if (userState.user.type === 'Supplier') {
        url = `https://tourconnect.ai/activate-ai-operators`;
      }

      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null

      AIToolsClicked();
    }

    const links = (() => {
      if (userState.user.userID) {
        return (<div style={{ maxHeight: '70px' }}>
          <ProfileLink
            ref="profileLink"
            className="app-bar-profile-link"
            showOnboardingAppBar={showOnboardingAppBar}
            companySlugName={getIn(['company', 'companyName'], userState)}
            {...this.props}
          />
          {
            !showMobileAppBar &&
              <div className="nav-link-container">
                <div
                  style={{ display: 'flex', alignItems: 'flex-start', minWidth: '810px', height: '65px' }}
                >
                  <HoverableMenuItem
                    {...this.props}
                    className="nav-link"
                    activeRoutes={[
                      '/workspace',
                      '/connections',
                    ]}
                    showSubMenu
                    subMenuItems={partnersMenu({ push: this.props.push })}
                  >
                    Partners
                  </HoverableMenuItem>
                  {
                    allApps && allApps.indexOf('s&m') > -1 && (
                      <HoverableMenuItem
                        {...this.props}
                        className="nav-link"
                        activeRoutes={[
                          '/profile',
                          '/partner-finder',
                          // '/newsfeed',
                        ]}
                        showSubMenu
                        subMenuItems={salesMarketingMenu({ push: this.props.push })}
                      >
                        Sales & Marketing
                      </HoverableMenuItem>
                    )
                  }
                  {
                    allApps && allApps.indexOf('contracting') > -1 && (
                      <HoverableMenuItem
                        {...this.props}
                        className="nav-link"
                        activeRoutes={[
                          '/contracting',
                        ]}
                        routeName={`/contracting/${userState.user.type === 'Supplier' ? 'supplier' : 'buyer'}-dashboard`}
                        showSubMenu
                        subMenuItems={
                          userState.user.type === 'Supplier'
                            ? supplierContractingMenu({
                              push: this.props.push,
                              rateTemplatesCount: userState.rateTemplatesCount,
                              contractListSearchParams,
                              contractListType,
                              templateListSearchParams,
                            })
                            : buyerContractingMenu({ push: this.props.push, contractListType, contractListSearchParams })
                        }
                      >
                        {languageSettings.Contracting}
                      </HoverableMenuItem>
                    )
                  }
                  <NavLink
                    {...this.props}
                    className="nav-link"
                    activeRoutes={
                          Boolean(usersAITools.length) ?
                              [`${process.env.NEW_SYSTEM_URL}/generative-ai/${usersAITools[0]}`]
                          : []
                        }
                    onClick={
                      Boolean(usersAITools.length) ?
                        () => {window.location = `${process.env.NEW_SYSTEM_URL}/generative-ai/${usersAITools[0]}?jwt=${localStorage.getItem('jwt')}`;}
                        : () => openURLInNewTab ()
                    }
                  >
                    AI Tools
                  </NavLink>
                  <Support helpwidget={this.props.helpwidget} walkthru={this.props.walkthru} openWalkThru={this.props.openWalkThru} />
                  {
                    allApps && allApps.indexOf('s&m') > -1 && (
                      <div className="nav-link" style={{ marginLeft: '1em' }}>
                        <GetVerified />
                      </div>
                    )
                  }
                </div>
                <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', flex: 1 }}>
                  <Notification/>
                  <WallWrapper hideOnSkip amazonOrange>
                    <RaisedButton
                      label="Upgrade"
                      labelStyle={{ padding: '4px' }}
                      secondary
                      style={{ lineHeight: 0 }}
                    />
                  </WallWrapper>
                </div>
              </div>
          }
        </div>);
      }
    })();

    return (
      <header className={classes} style={{ height: '64px' }}>
        <div className="app-bar-content">
          <Link className="tourconnect-logo" to="/" title="Dashboard">
            <img
              className="tourconnect-logo-globe"
              src={logoGlobeSrc}
            />
            <img
              className="tourconnect-logo-name"
              src={logoNameSrc}
              alt="tourconnect"
            />
          </Link>
          {links}
        </div>
        <MassMessageDialog />
      </header>
    );
  }

}

AppBar.propTypes = {
  dispatch: PropTypes.func,
  location: PropTypes.object,
  profile: PropTypes.object,
  user: PropTypes.object,
  className: PropTypes.string,
  connectionsStats: PropTypes.object,
  push: PropTypes.func,
  contractListSearchParams: PropTypes.object,
  templateListSearchParams: PropTypes.object,
  contractListType: PropTypes.string,
  AIToolsClicked: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  push: (...args) => dispatch(pushAction(...args)),
  openWalkThru: () => dispatch(openWalkThru()),
  AIToolsClicked: () => dispatch({ type: 'AITools_Clicked' }),
});
export default connect(({ contracting }) => ({
  contractListType: contracting.contractList.getIn(['list', 'listType']),
  contractListSearchParams: contracting.contractList.get('searchParams').toJS(),
  templateListSearchParams: {
    statusesFilter: contracting.templateList.get('statusesFilter').toJS(),
    showType: contracting.templateList.get('showType'),
  },
}), mapDispatchToProps)(AppBar);



// WEBPACK FOOTER //
// ./src/app/components/app-bar/app-bar.jsx